import React from "react"; 

export class CasinoMaratonPlacements extends React.Component {
    constructor(props) {
        super(props);
    }

    setPlace(nagrada, index) {
        if (nagrada.mjesto - this.props.info.nagradeLista[index-1].mjesto >= 2){
            return `${this.props.info.nagradeLista[index-1].mjesto+1}.-${nagrada.mjesto}. mjesto`;
        } else if (nagrada.mjesto - this.props.info.nagradeLista[index-1].mjesto == 1) {
            return `${nagrada.mjesto }. mjesto`;
        } 
    }

    render() { 
        return (
        <div>
            <div className="podium">
                <span className="first-place">
                    <span className="image"></span>
                    <span className="text">
                            <span className="left">1. mjesto</span>
                            <span className="right">{this.props.info && casino.utils.numberWithCurrencyFromated(this.props.info.nagradeLista[0].iznos, this.props.info.valuta)}</span>
                    </span>
                </span>
                <span className="second-place">
                    <span className="image"></span>
                    <span className="text">
                            <span className="left">2. mjesto</span>
                            <span className="right">{this.props.info && casino.utils.numberWithCurrencyFromated(this.props.info.nagradeLista[1].iznos, this.props.info.valuta)}</span>
                    </span>
                </span>
                <span className="third-place">
                    <span className="image"></span>
                    <span className="text">
                            <span className="left">3. mjesto</span>
                            <span className="right">{this.props.info && casino.utils.numberWithCurrencyFromated(this.props.info.nagradeLista[2].iznos, this.props.info.valuta)}</span>
                    </span>   
                </span>
            </div>
            <div className="placements">
                {this.props.info && this.props.info.nagradeLista.map((nagrada, index) => 
                    (index > 2 && <div key={index} className="placement"> 
                    <span>{this.setPlace(nagrada, index)}</span>
                    <span>{casino.utils.numberWithCurrencyFromated(nagrada.iznos, this.props.info.valuta)}</span>
                    </div>)         
                )}
            </div>
        </div>)
    }
}